<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box" v-loading="pageLoading">
            <div class="widthPC-90 margin-x-auto">
                <div class="fileNo text-right" v-if="baseInfo.fileNo">{{ baseInfo.fileNo }}</div>
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="2">备案公开</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目编号：</td>
                        <td>{{ baseInfo.projectCode }}</td>


                    </tr>
                    <tr>
                        <td class="font-bold">项目名称：</td>
                        <td>{{ baseInfo.projectName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">所属行业；</td>
                        <td>{{ baseInfo.industryName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">审核类型：</td>
                        <td>{{ baseInfo.auditTypeName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目所在地：</td>
                        <td>{{ baseInfo.projectAddress }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目总投资：</td>
                        <td>{{ baseInfo.totalMoney }}{{ baseInfo.unit }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目规模及内容</td>
                        <td>{{ baseInfo.scaleContent || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">建设单位：</td>
                        <td><span :class="baseInfo.hasContact ? 'active-color' : ''"
                                @click="baseInfo.hasContact && handlerLinkLocal('/contact/detail?id=' + baseInfo.projectDept + '&type=2')">{{
                                    baseInfo.projectDept }}</span></td>
                    </tr>
                    <tr>
                        <td class="font-bold">备案机关：</td>
                        <td>{{ baseInfo.fullName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">备案申报日期：</td>
                        <td>{{ baseInfo.applyTime || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">复核通过日期：</td>
                        <td>{{ baseInfo.finishDate }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">项目起止年限：</td>
                        <td>{{ baseInfo.projectStarttime }} 至 {{ baseInfo.projectEndtime }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">当前项目状态</td>
                        <td>{{ baseInfo.stateFlagName }}</td>
                    </tr>
                    <!-- <tr>
                    <td class="font-bold">占地面积</td>
                    <td>{{ baseInfo.stateFlagName}}</td>
                </tr>
                <tr>
                    <td class="font-bold">建筑面积</td>
                    <td>{{ baseInfo.stateFlagName}}</td>
                </tr> -->
                </table>
                <ad :type="2"></ad>
                <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'关联项目'" :pageType="2"
                    :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.projectDept + '）关联项目'" :pageType="1" :relatedByData="extend.relatedByCompanyName">
                </relatedBy>
                <relatedBy v-if="extend.relatedByAgencyService && extend.relatedByAgencyService.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.projectDept + '）关联产业链上游项目'" :pageType="3" :relatedByData="extend.relatedByAgencyService">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import relatedBy from '../components/relatedBy.vue';

export default {
    components: {
        relatedBy,
    },

    data() {
        return {
            id: this.$route.query.id || null,
            pageLoading: false,
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: '',
            },
            extend: {}
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let ajaxUrl = this.$api.common.RecordPublic.Detail() + '?id=' + this.id;
            this.pageLoading = true;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('公告数据详情', res);
                if(res.success) {
                    this.baseInfo = res.data || {};
                    this.extend = res.extend || {};
                }else {
                    this.$message.error(res.msg || '获取数据失败');
                }
                this.pageLoading = false;
            }).catch((err) => {
                this.pageLoading = false;
            });

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>